import Swal from "sweetalert2";

/**
 * Show a SweetAlert2 modal with custom message
 * @param {Object} options
 * @param {string} options.title - Title text
 * @param {string} options.message - Body message
 * @param {string} options.icon - 'success' | 'error' | 'info' | 'warning' | 'question'
 * @param {function} options.onBack - Callback on "Back" button click
 */
const showErrorAlert = ({ title = "Well done!", message, cancelText= 'Back' , icon = "success"}) => {
  Swal.fire({
    html:`<div class="mt-3">
      <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" 
      trigger="loop" 
      colors="primary:#f06548,secondary:#f7b84b" 
      style="width:120px;height:120px">
      </lord-icon><div class="mt-4 pt-2 fs-15">
      <h4>${title}</h4>
      <p class="text-muted mx-4 mb-0">${message}</p></div>
      </div>`,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: cancelText,
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      cancelButton: 'btn btn-danger w-xs mb-1',
    },
  });
};

export default showErrorAlert;
